const getContentDispositionFilename = (headers = {}) => {
  const disposition =
    headers["content-disposition"] || headers["Content-Disposition"] || "";
  const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) return decodeURIComponent(utf8Match[1]);

  const filenameMatch = disposition.match(/filename="?([^";]+)"?/i);
  if (filenameMatch?.[1]) return filenameMatch[1];

  return "";
};

export const downloadDocxBlob = (blobResponse, fallbackFilename) => {
  const blob = blobResponse instanceof Blob ? blobResponse : blobResponse?.data;

  if (!(blob instanceof Blob)) {
    throw new Error("Không nhận được file DOCX từ máy chủ.");
  }

  const filename =
    getContentDispositionFilename(blobResponse?.headers) ||
    fallbackFilename ||
    `giay-uy-quyen-${Date.now()}.docx`;

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = /\.(doc|docx)$/i.test(filename) ? filename : `${filename}.docx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
